module.exports = __webpack_public_path__ + "static/media/mercadolivre.d5fa70cd.svg";